<template>
  <div class="exp-wrapper">
    <div class="exp-header">
      <h2 class="title">{{expData.title}}</h2>
      <div class="info">
        <span class="date">{{expData.addtime | dateFilter}}</span>
        <ul class="keywords" v-if="expData.keywords && expData.keywords.length > 0">
          <li>关键词：</li>
          <li>{{expData.keywords.join('、')}}</li>
        </ul>
      </div>
    </div>
    <div class="baseinfo">
      <div class="avatar lazy-load">
        <img :src="expData.show_avatar" v-if="expData.show_avatar" alt="">
        <img :src="expData.avatar" v-else alt="">
      </div>
      <div class="awards">
        <div class="award-item" v-if="expData.is_excellent == 1">
          <i class="award-icon graduate"></i>
        </div>
        <div class="award-item" v-if="expData.is_newstar == 1">
          <i class="award-icon star"></i>
        </div>
      </div>
      <div class="name">{{expData.name}}</div>
      <div class="school-info">
        <div class="school">
          <div class="school-name">{{expData.school_from}} | </div>
          <div class="major">{{expData.school_major}}</div>
        </div>
        <div class="grades">
          <p v-if="expData.gpa">GPA: {{expData.gpa}}</p>
          <p v-if="expData.toefl">TOEFL: {{expData.toefl}}</p>
          <p v-if="expData.gre">GRE: {{expData.gre}}</p>
          <p v-if="expData.wes">WES: {{expData.wes}}</p>
          <p v-if="expData.ielts">IELTS : {{expData.ielts}}</p>
          <p v-if="expData.testdaf">TestDaF: {{expData.testdaf}}</p>
          <p v-if="expData.jlpt">JLPT: {{expData.jlpt}}</p>
        </div>
      </div>
    </div>
    <div class="offer-school" v-if="expData.offer && expData.offer.length > 0">
      <div class="exp-title">录取院校</div>
      <ul class="school-list">
        <li class="school-item" v-for="(item, index) in expData.offer">
          <div class="logo"><img :src="item.logo" alt=""></div>
          <div class="content">
            <div class="school-name">{{item.name}}<span v-if="index == 0">最终去向</span></div>
            <div class="project">项目：{{item.project}}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="teachers" v-if="expData.description">
      <div class="exp-title">Ta的老师</div>
      <div class="teacher-text">“{{expData.description}}”</div>
      <div class="teacher-list" ref="teacherInnerBox">
        <div class="teacher-item" v-for="item in teacherList">
          <div class="teacher-avatar lazy-load"><img :src="item.avatar" alt=""></div>
          <div class="teacher-info">
            <div class="name">{{item.stagename}}</div>
            <div class="teacher-title">
              <p>{{item.title1}}</p>
              <p>{{item.title2}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="exp-article">
      <div class="exp-title">经验分享</div>
      <div class="exp-article-container">
        <div class="article-context" v-html="expData.content"></div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .exp-wrapper{
    .exp-header{
      background: url('/Application/Home/Resource/static/images/mobile/experience-header.png') no-repeat center center;
      background-size: cover;
      color: #FFF;
      width: 100%;
      padding: 24px 20px 16px;
      h2{
        font-size: 18px;
        line-height: 28px;
        font-weight: 600;
      }
      .info{
        display: flex;
        align-items: center;
        margin-top: 8px;
        color: rgba(255,255,255,.6);
        font-size: 13px;
        line-height: 13px;
        .keywords{
          display: flex;
          margin-left: 12px;
        }
      }
    }
    .baseinfo{
      position: relative;
      margin: 40px 16px 16px;
      background: #F3F3F3;
      border-radius: 4px;
      padding: 0 12px 16px 12px;
      .avatar{
        width: 42px;
        height: 42px;
        border: 2px solid #FFF;
        border-radius: 50%;
        overflow: hidden;
        margin-top: -22px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .awards{
        position: absolute;
        right: 8px;
        top: -4px;
        display: flex;
        justify-content: center;
        align-items: center;
        .award-icon{
          display: block;
          width: 40px;
          height: 44px;
          &.graduate{
            background: url('/Application/Home/Resource/static/images/achievement/graduate-badge-small.png') no-repeat center center;
            background-size: cover;
          }
          &.star{
            background: url('/Application/Home/Resource/static/images/achievement/scholarship-badge-small.png') no-repeat center center;
            background-size: cover;
          }
        }
      }
      .name{
        margin-top: 10px;
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        color: #333;
      }
      .school-info{
        margin-top: 8px;
        .school{
          display: flex;
          align-items: center;
          font-size: 12px;
          line-height: 18px;
          color: #666;
        }
        .grades{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          p{
            padding: 0 4px;
            height: 20px;
            line-height: 20px;
            border: 1px solid #CCC;
            font-size: 12px;
            color: #666;
            margin: 4px 4px 0 0;
            white-space: nowrap;
            border-radius: 4px;
          }
        }
      }
    }
    .exp-title{
      position: relative;
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
      padding-left: 6px;
      color: #333;
      &::after{
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 2px;
        height: 16px;
        background: @cano;
      }
    }
    .offer-school{
      padding: 0 16px 4px;
      .school-list{
        .school-item{
          padding: 16px 0;
          border-bottom: 1px solid #EEE;
          display: flex;
          align-items: center;
          &:last-child{
            border-bottom: 0;
          }
          .logo{
            flex-shrink: 0;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            overflow: hidden;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .content{
            padding-left: 12px;
            .school-name{
              display: flex;
              align-items: center;
              font-size: 14px;
              line-height: 14px;
              color: #333;
              font-weight: bold;
              span{
                margin-left: 8px;
                padding: 0 4px;
                height: 20px;
                border-radius: 20px;
                background: rgba(62, 187, 159, 0.91);
                font-size: 12px;
                line-height: 20px;
                color: #FFF;
                font-weight: normal;
              }
            }
            .project{
              margin-top: 8px;
              font-size: 12px;
              line-height: 18px;
              color: #666;
            }
          }
        }
      }
    }
    .teachers{
      border-top: 10px solid #F8F8F8;
      padding: 14px 16px 0;
      .teacher-text{
        padding: 12px;
        background: #F3F3F3;
        border-radius: 6px;
        font-size: 12px;
        line-height: 20px;
        color: #333;
        margin-top: 16px;
      }
      .teacher-item{
        padding: 16px 0;
        display: flex;
        align-items: flex-start;
        border-bottom: 1px solid #EEE;
        &:last-child{
          border-bottom: 0;
        }
        .teacher-avatar{
          width: 48px;
          height: 48px;
          border-radius: 50%;
          flex-shrink: 0;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .teacher-info{
          padding-left: 12px;
          .name{
            font-size: 14px;
            line-height: 14px;
            margin-top: 2px;
            color: #333;
            font-weight: 600;
          }
          .teacher-title{
            margin-top: 7px;
            font-size: 12px;
            line-height: 18px;
            color: #666;
          }
        }
      }
    }
    .exp-article{
      border-top: 10px solid #F8F8F8;
      padding: 14px 16px 0;
      .exp-article-container{
        margin-top: 12px;
        line-height: 24px;
        font-size: 14px;
        color: #333;
        padding-bottom: 20px;
      }
    }
  }
</style>

<script>
  export default {
    data() {
      return {
        dataDone: false,
        expData: {},
      }
    },
    created() {
      this.$store.commit('setActiveMenu', 'achievement');
      this.$root.post('/Star/get_student_article_detail', {
        id: this.$route.params.id
      }).then(data => {
        console.log(data);
        this.dataDone = true;
        if(data.keywords) {
          data.keywords = data.keywords.split(',');
        }
        data.content = data.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
        this.expData = data || {};
        this.teacherList = data.private || [];
      })
    },
    methods: {},
    filters: {
      dateFilter(date) {
        return moment.unix(date).format('YYYY/MM/DD');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Star/expDetail.vue